import type {
    SortableObjectWithSortOrderProp
} from '#x1-base/types';

export const sortWithSortOrderAscFn = <T extends SortableObjectWithSortOrderProp>(
    a: T,
    b: T
) => a.sortOrder - b.sortOrder;
